import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import '../css/Login.css';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '', remember: false });
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.postlii.com';

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}/api/login`, formData);
      const userData = response.data.user || {};
      const token = response.data.token || userData.token || '';
      const isAdminLogin = response.data.user?.isAdminLogin || false;

      if (userData?.userId) {
        localStorage.setItem('userId', userData.userId);
        if (token) {
          localStorage.setItem('authToken', token);
        } else {
          const tempToken = `temp_${Date.now()}_${userData.userId}`;
          localStorage.setItem('authToken', tempToken);
        }

        // Show different toast message for admin login
        toast.success(isAdminLogin ? 'Admin Login Successful!' : 'Login Successful!', {
          position: 'top-right',
        });

        // 🔍 Check profile_status from API
        const profileRes = await axios.get(
          `${API_BASE_URL}/api/user/profile-status/${userData.userId}`,
          {
            headers: { Authorization: `Bearer ${token}` }, // Include token if required
          }
        );
        const profileStatus = profileRes.data?.profile_status;

        setTimeout(() => {
          const redirectToken = token || localStorage.getItem('authToken') || '';
          const redirectURL =
            profileStatus === 0
              ? `https://postlii.com/Variations/realtors-Variation?token=${redirectToken}&userId=${userData.userId}`
              : `https://postlii.com/Variations/variation?token=${redirectToken}&userId=${userData.userId}`;
          console.log(redirectURL);
          window.location.href = redirectURL;
        }, 2000);
      } else {
        toast.error('User ID not found!', { position: 'top-right' });
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.message || 'Login failed', {
        position: 'top-right',
      });
    }
  };

  const handleGoogleLogin = () => {
    window.location.href = `${API_BASE_URL}/auth/google`;
  };

  const handleFacebookLogin = () => {
    window.location.href = `${API_BASE_URL}/auth/facebook`;
  };

  return (
    <div className="login-container">
      <div className="Login-left">
        <h1>Welcome to postlii</h1>
        <strong>Log in to continue your journey.</strong>
        <br />
        <p>
          Access your dashboard, share your thoughts, connect with your network,
          and stay updated — all in one place.
        </p>
        <div className="hero-image">
          <img src={'signupp.jpg'} alt="Community Connection" />
        </div>
      </div>

      <div className="Login-right">
        <div className="Login-right-box">
          <h2>Log in to your account</h2>
          <p>Join postlii to connect with your community</p>
          <div className="Login-Social-Login">
            <button className="login-google-btn" onClick={handleGoogleLogin}>
              Sign Up with Google
            </button>
            <button className="login-facebook-btn" onClick={handleFacebookLogin}>
              Sign Up with Facebook
            </button>
          </div>

          <div className="login-divider">
            <span>or</span>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="Login">
              <div className="input-wrapper">
                <input
                  type="email"
                  name="email"
                  placeholder="Email or Phone"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-wrapper">
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="remember-me">
                <input
                  type="checkbox"
                  id="remember"
                  name="remember"
                  checked={formData.remember}
                  onChange={(e) =>
                    setFormData({ ...formData, remember: e.target.checked })
                  }
                />
                <label htmlFor="remember">Remember me</label>
              </div>

              <button className="Login-button" type="submit">
                Log in
              </button>

              <p style={{ fontSize: '14px', color: '#6b7280', marginTop: '-16px' }}>
                Don’t have an account?{' '}
                <a href="/" className="signup-link">
                  Sign up
                </a>
              </p>
            </div>
          </form>

          <ToastContainer closeButton={false} />
        </div>
      </div>
    </div>
  );
};

export default Login;